export default __webpack_public_path__ + "091325b4b8e192fcd636b9af317a8e30.png";